/* eslint-disable */
//const domain = 'http://localhost:5102/api/v1/location';
const hostname = window && window.location && window.location.origin;
const basePath = "/firm_api";
const domain = `${hostname}${basePath}/v1/location`

/* eslint-disable end */

export default {
    getAllLocations: `${domain}/GetLocationsData`,
    saveAllLocations: `${domain}/AddOrUpdateLocation`,
    deleteLocation: `${domain}/DeleteLocation`

};
